import React from "react";
import { createRoot } from "react-dom/client";
import Button from "../../Button/Button";
import { CopyToClipboard } from "react-copy-to-clipboard";
import "./taxonomyString.scss";

let taxonomyStringRoot = null;

const TaxonomyString = {
	loadTaxonomyString: (className) => {
		TaxonomyString.taxonomyWrapper(className);
	},

	closeOpenTaxonomyString: (event) => {
		// If user clicks inside the element, or on any 'trrigers' do nothing
		if (!event) return;
		if (event.target.closest(`.taxonomy__container`) || event.target.closest(".icon__container") || event.target.closest(".campaign--taxonomy--container")) return;
		const taxonomyContainer = document.querySelectorAll(`.taxonomy__container`);

		if (taxonomyContainer) {
			taxonomyContainer.forEach((node) => {
				// If user clicks outside the element, hide it!
				if (node.classList.contains("open--string")) {
					node.classList.remove("open--string");
				}
			});
		}
	},

	updateTaxonomyString: (event, value, dimensions, className) => {
		if (taxonomyStringRoot) {
			taxonomyStringRoot.unmount();
		}
		const taxonomyContainer = document.querySelector(`.${className}`);
		taxonomyContainer.classList.add("open--string");
		taxonomyContainer.setAttribute("style", `top: ${event.clientY + window.scrollY + 15}px; left: ${event.clientX - 25}px; position: absolute;`);
		taxonomyStringRoot = createRoot(taxonomyContainer);
		taxonomyStringRoot.render(TaxonomyString.buildDynamicString(dimensions, value));
	},

	updateNotes: (event, value, dimensions, className, seeAllCallback, campaignName, location) => {
		if (taxonomyStringRoot) {
			taxonomyStringRoot.unmount();
		}
		// sorting the note based on their creation date in descending order
		const notes = JSON.parse(value).sort((x, y) => new Date(y.CreatedDate) - new Date(x.CreatedDate));
		const taxonomyContainer = document.querySelector(`.${className}`);
		taxonomyContainer.classList.add("open--string");
		taxonomyContainer.setAttribute(
			"style",
			`top: ${event.clientY + window.scrollY - 19}px; right: ${location === "traffickingGrid" ? "270px;" : "150px;"} position: absolute;`
		);
		taxonomyStringRoot = createRoot(taxonomyContainer);
		taxonomyStringRoot.render(TaxonomyString.buildNotes(dimensions, notes, seeAllCallback, campaignName));
	},

	buildNotes: (dimensions, notes, seeAllCallback, campaignName) => {
		const user = notes[0].User ? notes[0].User.FullName : null;
		let formattedDate = new Date(notes[0].CreatedDate);
		formattedDate = formattedDate.toLocaleDateString() + " " + formattedDate.toLocaleTimeString();
		const comment = notes[0].Comment;
		return (
			<div className="flex--ai--c">
				<div className="trafficking_user">{user}</div>
				<div className="trafficking_date">{formattedDate}</div>
				<div className="trafficking_comment">{comment}</div>
				{notes.length > 1 && (
					<div
						className="seeAllButton"
						onClick={(evt) => {
							const taxonomyContainer = document.querySelectorAll(`.taxonomy__container`);
							if (taxonomyContainer) {
								taxonomyContainer.forEach((node) => {
									if (node.classList.contains("open--string")) {
										node.classList.remove("open--string");
									}
								});
							}
							seeAllCallback(notes, campaignName);
						}}
					>
						See All
					</div>
				)}
			</div>
		);
	},

	taxonomyWrapper: (className) => {
		const body = document.querySelector("body");
		const taxonomyContainer = document.querySelector(`.${className}`);
		if (!taxonomyContainer) {
			const taxonomyWrapper = document.createElement("DIV");
			taxonomyWrapper.classList.add(className, "taxonomy__container");
			body.appendChild(taxonomyWrapper);
		}
	},

	buildDynamicString: (dimensions, value) => {
		return (
			<div className="flex__container flex--ai--c">
				<CopyToClipboard text={value}>
					<Button className="btn primary" label="Copy" data-tracking-id-alt="copy-taxonomy-string" />
				</CopyToClipboard>
				<span className="taxonomy--string">{value || "N/A"}</span>
			</div>
		);
	}
};

export default TaxonomyString;
